window.__I18N__ = require('./entry.i18n')(require('../i18n/ru.json'), 'ru');